<template>
  <b-card no-body class="job-item" tag="article">
    <b-card-body>
      <router-link class="job-item__body" :to="to">
        <b-img-lazy fluid v-bind="imgProps" :src="jobImage"></b-img-lazy>
      </router-link>
    </b-card-body>
    <div class="job-item__content">
      <b-card-title title-tag="h5">${{ job.price | price }}/day</b-card-title>
      <b-card-sub-title sub-title-tag="p">{{
        job.name | tooLong(40)
      }}</b-card-sub-title>
    </div>
  </b-card>
</template>
<script>
/**
 * ==================================================================================
 * Job Item card
 * ==================================================================================
 **/

import Job from '@/models/Job'

export default {
  props: {
    job: {
      type: [Job, Object],
      required: true
    }
  },
  computed: {
    jobImage() {
      if (!this.job || !this.job.gallery || !this.job.gallery.length)
        return require('@/assets/images/img-placeholder.svg')
      return (
        this.job.gallery[0].thumb_url ||
        this.job.gallery[0].permanent_url ||
        this.job.gallery[0].url
      )
    },

    to() {
      return {
        name: 'job.view-job-page',
        params: {
          id: this.job.permalink,
          title: this.job.name.replace(/ +/g, '-').toLowerCase()
        }
      }
    }
  },
  data() {
    return {
      imgProps: {
        center: true,
        blank: true,
        height: '150px',
        width: 'auto'
      }
    }
  }
}
</script>
